import styled from "styled-components";

const PageHeading = styled.h1`
  font-weight: 900;
`;

PageHeading.displayName = "PageHeading";

export default PageHeading;
